exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header-onboarding-process{line-height:60px;height:60px;vertical-align:middle;position:relative;margin-right:10px;color:#353d45}.header-onboarding-process-container{display:flex;justify-content:center;align-items:center;gap:6px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/components/Header/components/OnboardingProcess/style.css
 ** module id = 1993
 ** module chunks = 73
 **/